/** @format */

import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HmfCheckboxComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'shared-totf-components-compare-checkbox',
	imports: [CommonModule, HmfCheckboxComponent],
	templateUrl: './compare-checkbox.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompareCheckboxComponent {
	readonly checked = input(false);
	readonly check = output<boolean>();
	readonly tabPressed = output<void>();

	onCompareChange(event: MouseEvent): void {
		event.preventDefault();
		this.check.emit(!this.checked());
	}
}
